import React from 'react';
import { Link } from 'react-router-dom';

const productLinks = [
  { label: 'Overview', path: '/product' },
  { label: 'Control Tower', path: '/control-tower' },
  { label: 'Resolve Requests', path: '/product/resolve-requests' },
  { label: 'Access Management', path: '/product/access-management' },
  { label: 'Automation Builder', path: '/product/automation-builder' },
  { label: 'Knowledge', path: '/product/knowledge' },
  { label: 'Endpoints', path: '/endpoints' },
  { label: 'SaaS Governance', path: '/saas' },
  { label: 'Security Response', path: '/security' },
  { label: 'Asset Graph', path: '/assets' },
  { label: 'Cost Intelligence', path: '/cost' },
  { label: 'Ticketing & ITSM', path: '/product/itsm' },
];

const resourceLinks = [
  { label: 'Documentation', path: '/docs' },
  { label: 'Templates', path: '/templates' },
  { label: 'Comparisons', path: '/comparisons' },
];

const companyLinks = [
  { label: 'Integrations', path: '/integrations' },
  { label: 'Security & Trust', path: '/trust' },
  { label: 'Pricing', path: '/pricing' },
  { label: 'Request Demo', path: '/demo/request' },
];

const legalLinks = [
  { label: 'Privacy Policy', path: '/privacy' },
  { label: 'Terms of Service', path: '/terms' },
  { label: 'Status', path: '/status' },
  { label: 'Contact', path: '/contact' },
];

export const MarketingFooter = () => {
  return (
    <footer className="bg-white border-t border-border">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 rounded-lg bg-primary flex items-center justify-center">
                <span className="text-primary-foreground font-bold text-xs">V</span>
              </div>
              <span className="text-base font-semibold text-foreground">Vedaya AI</span>
            </Link>
            <p className="text-xs text-muted-foreground">
              IT lifecycle management platform.
              <br />
              San Francisco, CA
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground uppercase tracking-wide mb-4">Product</h4>
            <ul className="space-y-2">
              {productLinks.slice(0, 6).map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground uppercase tracking-wide mb-4">Platform</h4>
            <ul className="space-y-2">
              {productLinks.slice(6).map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground uppercase tracking-wide mb-4">Resources</h4>
            <ul className="space-y-2">
              {resourceLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground uppercase tracking-wide mb-4">Company</h4>
            <ul className="space-y-2">
              {companyLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Vedaya AI Inc. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            {legalLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-xs text-muted-foreground hover:text-foreground transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
